import React from "react";
import { Box, Typography, alpha } from "@mui/material";

const NAVY = "#0B1E2D";
const NAVY_DARK = "#071521";
const GOLD = "#058dd0";
const TEXT_SECONDARY = "#6B7280";

export interface PageHeaderProps {
  title: string;
  subtitle?: React.ReactNode;
  icon?: React.ReactElement;
  /** Right-aligned slot (search, filters, primary CTA, etc.). */
  actions?: React.ReactNode;
  /** Alias for `actions` — matches the AppPage spec's `right` prop. */
  right?: React.ReactNode;
}

export default function PageHeader({ title, subtitle, icon, actions, right }: PageHeaderProps) {
  const trailing = actions ?? right;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 2,
        mb: 2.5,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        {icon && (
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: `linear-gradient(135deg, ${NAVY} 0%, ${NAVY_DARK} 100%)`,
              boxShadow: `0 6px 18px ${alpha(NAVY, 0.35)}`,
              border: `1px solid ${alpha(GOLD, 0.35)}`,
            }}
          >
            {React.cloneElement(icon, { sx: { fontSize: 22, color: GOLD } })}
          </Box>
        )}
        <Box>
          <Typography fontSize={22} fontWeight={800} color={NAVY} letterSpacing="-0.02em">
            {title}
          </Typography>
          {subtitle && (
            <Typography fontSize={12} color={TEXT_SECONDARY}>
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>
      {trailing && (
        <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}>
          {trailing}
        </Box>
      )}
    </Box>
  );
}
